import React from "react"

function Header(){
    return(
        <div className="header">
            The Maze 
        </div>
    )
}

export default Header